import React from "react";
import Input from "../Input";
import { FormattedMessage } from "react-intl";

export default (props) => {
  return (
    <Input
      {...props}
      type="email"
      validations={{ ...props.validations, isEmail: true }}
      validationErrors={{
        ...props.validationErrors,
        isEmail: (
          <FormattedMessage
            id="components.atoms.Form.Input.Email.invalidEmail"
            defaultMessage="This field must be an email"
          />
        ),
      }}
    />
  );
};
